import React, { useState, useContext, useEffect } from 'react';
import BuilderContext from '../../../../../context/BuilderContext';
import { api } from '../../../../../api/api';
import InsertField from '../../../../common/InsertField';
import Button from '../../../../common/Button';
import {getErrorByStatus} from "../../helpers";
import TranslationContext from '../../../../../context/TranslationContext';
import UserContext from '../../../../../context/UserContext';


const fieldNameMap = () => {
    const datamap = new Map()
    datamap.set("lastname", { message: "Укажите фамилию", phr: "ins_lastname" })
    datamap.set("firstname", { message: "Укажите имя", phr: "ins_firstname" })
    datamap.set("middlename", { message: "Укажите отчество", phr: "ins_middlename" })
    datamap.set("birthday", { message: "Укажите день рождения", phr: "ins_birthdate" }) 
    datamap.set("room", { message: "Укажите номер комнаты", phr: "ins_room" })
    datamap.set("phone", { message: "Укажите номер телефона", phr: "ins_phone" })
    datamap.set("code", { message: "Укажите ваш код", phr: "ins_code" })
    return datamap
}

export const ExtraActionButBlock = ({interactive, external, start, setExternalUnit}) => {
   
    const {language} = useContext(TranslationContext)

    if (external === undefined || external.length < 1) {
        return (<></>)
    }

    const handlerUnitStart = (unit)=> {
        return () => {
            setExternalUnit(unit);
            start()
        }
    } 
//    debugger
   return (<>
        {
            external.map((k) => {
                return <Button 
                key={k.id}
                onClick={handlerUnitStart(k)}
                description={language ==="ru" ? k.render_name : k.render_name_en }
                disabled={!interactive}
                />
            })
        }
   </>)
}

export const ExtraActionAuth = ({setAccess, handlerBackBtn, external}) => {

    const {getTranslation, language} = useContext(TranslationContext)
    const {setApiWait} = useContext(UserContext)

    const [inputData, setInputData] = useState({})
    const [error, setError] = useState("")
    const [errorMsg, setErrorMsg] = useState("")
    
    useEffect(() => {
        if (error !== "") {
            if (getTranslation(error)!=="") {setErrorMsg(getTranslation(error))} else {setErrorMsg(error)}  
        }
    },[getTranslation, error])

    if (external.id === 0) {
        return (<></>)
    }

    const mm = fieldNameMap()
    const handlerSendData = () => {
        // console.log(inputData)
        setApiWait(true)
        api.sendExternalAuthCreds(external.id, inputData).then(res => {
            if (res.status === 200) {
                setError("")
                setAccess(true)
            } 
        }).catch(err => {
            if (err.response.status === 400) {
                setError('err_validation')
                return
            }
            if (err.response.status === 429) {
                setError('err_toomany')
                return
            }
            if (err.response.status === 463) {
                setError('недостаточно данных во внешней системе')
                return
            }
            getErrorByStatus(err.response.status, setError, getTranslation)
        }).finally(() => setApiWait(false));
    }

    const handlerEditData = (key) => {
        return (value) => {
            setInputData(prev => {
                const data = {...prev}; 
                data[key] = value;
                return data;
            })
        }
    }

    const prepMetaData = () => {
        const data = []
        external.lastname && data.push("lastname")
        external.firstname && data.push("firstname")
        external.middlename && data.push("middlename")
        external.birthday && data.push("birthday")
        external.phone && data.push("phone")
        external.code && data.push("code")
        external.room && data.push("room")

        return data
    } 
    return(<>
        {
            prepMetaData().map(v => {
                const r = mm.get(v)
                if (v === "code") {
                    return <InsertDataBlock
                        key={v} 
                        message={(language ==="ru") ? external.code_description: external.code_description_en}
                        // phrase={r.phr}
                        setDataHandler={handlerEditData(v)}
                    />
                }
                return <InsertDataBlock
                    key={v} 
                    message={getTranslation(r.phr) === "" ? r.message : getTranslation(r.phr)}
                    phrase={r.phr}
                    setDataHandler={handlerEditData(v)}
                />
            })
        }
        {
            (error !== "") && <p data-id_phrase={error} >{errorMsg}</p>
        }
        <span data-id_phrase="ins_phone"></span>
        <Button  onClick={handlerSendData} description={"Продолжить"} idPhrase={"next"}/>
        <Button  onClick={handlerBackBtn} description={"Назад"} idPhrase={"back"}/>
    </>)
}


const ExtraAction = (props) => {

    const {external} = useContext(BuilderContext)
    const {getTranslation} = useContext(TranslationContext)
    const {setApiWait} = useContext(UserContext)

    const [inputData, setInputData] = useState({})
    const [error, setError] = useState("")
    const [errorMsg, setErrorMsg] = useState("")

    
    useEffect(() => {
        if (error !== "") {
            if (getTranslation(error)!=="") {setErrorMsg(getTranslation(error))} else {setErrorMsg(error)}  
        }
    },[getTranslation, error])

    const mm = fieldNameMap()
    const handlerSendData = () => {
        // console.log(inputData)
        setApiWait(true)
        api.sendExternalAuthCreds(inputData).then(res => {
            if (res.status === 200) {
                setError("")
                props.setAccess(true)
            } 
        }).catch(err => {
            if (err.response.status === 400) {
                setError('err_validation')
                return
            }
            getErrorByStatus(err.response.status, setError, getTranslation)
        }).finally(() => setApiWait(false));
    }

    const handlerEditData = (key) => {
        return (value) => {
            setInputData(prev => {
                const data = {...prev}; 
                data[key] = value;
                return data;
            })
        }
    }

    return(<>
        {
            external.vars.map(v => {
                const r = mm.get(v)
                return <InsertDataBlock
                    key={v} 
                    message={getTranslation(r.phr) === "" ? r.message : getTranslation(r.phr)}
                    phrase={r.phr}
                    setDataHandler={handlerEditData(v)}
                />
            })
        }
        {
            (error !== "") && <p data-id_phrase={error} >{errorMsg}</p>
        }
        <span data-id_phrase="ins_phone"></span>
        <Button  onClick={handlerSendData} description={"Продолжить"} idPhrase={"next"}/>
        <Button  onClick={props.handlerBackBtn} description={"Назад"} idPhrase={"back"}/>
    </>)
}


const InsertDataBlock = ({message, setDataHandler, phrase}) => {

    const handleChangeData =(e) =>{
        setDataHandler(e.target.value)
    }

    return (<>
        <span data-id_phrase={phrase}>{message}</span>
        <InsertField onChange={handleChangeData}/>
    </>)
}

export default ExtraActionAuth 